import React from "react";
import {
  SERVICE_LABOR_COLOR,
  SERVICE_AREA_FILL_OPACITY,
  SUPPORT_AREA_FILL,
  SUPPORT_AREA_FILL_OPACITY,
  PRIMARY_LABOR_COLOR,
} from "./VisualCustomerLineChartForChartCard2";

// Week cell for the labor bar's chart mode: weekly hours + grade, then a
// legend for the three series drawn in every day's chart.
function WeekChartLegendCard({ header, earnedToggle }) {
  const label1 = earnedToggle ? "Earned" : "Forecasted";
  const label2 = earnedToggle ? "Used" : "Scheduled";
  const rows = [
    {
      label: `${label1} Service`,
      swatch: (
        <span
          className="w-3 h-3 rounded-[3px] shrink-0"
          style={{
            backgroundColor: SERVICE_LABOR_COLOR,
            opacity: SERVICE_AREA_FILL_OPACITY + 0.3,
          }}
        />
      ),
    },
    {
      label: `${label1} Support`,
      swatch: (
        <span
          className="w-3 h-3 rounded-[3px] shrink-0"
          style={{
            backgroundColor: SUPPORT_AREA_FILL,
            opacity: SUPPORT_AREA_FILL_OPACITY + 0.3,
          }}
        />
      ),
    },
    {
      label: `${label2} Labor`,
      swatch: (
        <span
          className="w-3 shrink-0"
          style={{ borderTop: `2px solid ${PRIMARY_LABOR_COLOR}` }}
        />
      ),
    },
  ];

  return (
    <div className="w-full flex flex-col gap-1.5 pt-1">
      {header}
      <div className="flex flex-col gap-2.5 mt-4">
        {rows.map((r) => (
          <div key={r.label} className="flex items-center gap-2 text-xxs text-slate-600">
            {r.swatch}
            <span>{r.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default WeekChartLegendCard;
